import { FIELD_TYPES } from "../../utils/constants";

const isPharmacySelected = field => {
  const radioButtonField = field?.fieldLayouts?.[0]?.containerFields?.find(
    f => f.type === FIELD_TYPES.formRadioButtons
  );
  return radioButtonField.options?.[0]?.selected === "true";
};

export default {
  container: {
    update: (field, appData) => {
      const pharmacyState = field?.data?.state_province;

      if (pharmacyState && isPharmacySelected(field)) {
        const {
          values,
          screenValidation: { fields: fieldsArray },
          settings
        } = appData;
        const isValid = pharmacyState === values.state;
        const fieldObject = {
          fieldName: field.name,
          isValid,
          errorMessage: !isValid
            ? settings.translations.the_pharmacy_must_be_in_the_same_state
            : null,
          title: field.title
        };
        const index = fieldsArray.findIndex(
          fieldItem => fieldItem.fieldName === field.name
        );

        if (index > -1) {
          fieldsArray[index] = fieldObject;
        } else {
          fieldsArray.push(fieldObject);
        }
      }
    }
  }
};
